import React from 'react';
import FloatingCtaItem from './floating-cta-item';
import { Mobile } from '../../app-responsive';

const FloatingCta = (props) => {
  const { ctas } = props;
  return (
    <Mobile>
      {isMobile => (
        <ul className="floating-cta-wrapper">
          {ctas.map((cta, ctaIndex) => (
            <li key={ctaIndex.toString()}>
              <FloatingCtaItem isMobile={isMobile} {...cta} />
            </li>
          ))}
        </ul>
      )}
    </Mobile>
  );
};

export default FloatingCta;
